import React from "react";
import PageWrapper from "../components/PageWrapper";
import Hero from "../sections/landing8/Hero";
import Features from "../sections/landing8/Features";
import Testimonials from "../sections/landing8/Testimonials";
import Services from "../sections/landing1/Services";
import Content1 from "../sections/landing1/Content1";
import Contact from "../sections/landing8/Contact";
import Founders from "../sections/landing8/Founders";
import SEO from "../components/seo";

const Index = ({data}) => {
  return (
    <>
      <PageWrapper
        headerConfig={{
          theme: "dark",
          align: "right",
          variant: "danger",
          isFluid: true,
          button: "cta", // cta, account, null
        }}
        footerConfig={{
          style: "style3", //style1, style2
        }}
      > 
        <SEO title={data.prismicHomepage.data.meta_title.text} description={data.prismicHomepage.data.meta_description.text}/>
        <Hero data={data.prismicHomepage.data} />
        <Content1 data={data.prismicHomepage.data}/>
        <Services data={data.prismicHomepage.data}/>
        <div className="gradient-sections-wrapper bg-gradient-1">
          <Features data={data.prismicHomepage.data}/>
        </div>
        <Founders data={data.prismicHomepage.data}/>
        <Contact />
      </PageWrapper>
    </>
  );
};
export default Index;


export const query = graphql`
query MyQuery {
  prismicHomepage {
    data {
      about_us_image {
        url
        alt
      }
      about_the_founders_section_heading {
        text
      }
      about_us_paragraph {
        text
        html
      }
      about_us_quote {
        text
      }
      about_us_section_heading {
        text
      }
      about_us_sub_heading {
        text
      }
      content_block {
        text
      }
      content_blocks {
        step_title {
          text
        }
        step_paragraph {
          text
        }
        number_images {
          url
        }
      }
      cta_button_text {
        text
      }
      enquire_section_header {
        text
      }
      enquire_sub_heading {
        text
      }
      founder_description_one {
        text
      }
      founder_description_two {
        text
      }
      founder_title_one {
        text
      }
      founder_title_two {
        text
      }
      founders_image_1 {
        url
        alt
      }
      hero_image {
        alt
        url
      }
      hero_sub_text {
        text
      }
      hero_text {
        text
      }
      image_founders_2 {
        url
        alt
      }
      image_founders_3 {
        alt
        url
      }
      image_founders_4 {
        alt
        url
      }
      our_services {
        service_copy {
          text
        }
        service_title {
          text
        }
        service_image {
          url
          alt
        }
      }
      our_services_section_heading {
        text
      }
      our_services_sub_heading {
        text
      }
      meta_description {
        text
      }
      meta_title {
        text
      }
    }
  }
}

`


